import { render } from "./ProjectTestModelPhaseChangedWarningModal.vue?vue&type=template&id=47091913"
import script from "./ProjectTestModelPhaseChangedWarningModal.vue?vue&type=script&lang=js"
export * from "./ProjectTestModelPhaseChangedWarningModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__